import { motionState, STATUS_COLORS, fmtDuration, fmtClock, ageSeconds, unitLabel } from "./gpsUtils";

const mono = "'IBM Plex Mono', monospace";

function Row({ p, now, onFocus }) {
  const state = motionState(p, now);
  const color = STATUS_COLORS[state];
  let detail;
  if (state === "moving") detail = `${Math.round(p.speed_mph || 0)} MPH`;
  else if (state === "stopped") detail = `STOPPED ${p.stopped_since ? fmtDuration((now - new Date(p.stopped_since).getTime()) / 1000) : ""}`;
  else detail = `${state === "stale" ? "STALE" : "NO SIGNAL"} ${fmtDuration(ageSeconds(p, now))}`;
  return (
    <div data-testid={`gps-unit-row-${p.mapped_unit_name}`} onClick={() => onFocus(p)}
      style={{ padding: "6px 10px", borderBottom: "1px solid #1c2530", cursor: "pointer", borderLeft: `3px solid ${color}` }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "#121c26"; }} onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 6 }}>
        <span style={{ color: "#FFF", fontWeight: 700 }}>{p.mapped_unit_name} <span style={{ color: "#6A7A8A", fontWeight: 500 }}>{unitLabel(p)}</span></span>
        <span data-testid={`gps-unit-state-${p.mapped_unit_name}`} style={{ color, fontWeight: 700 }}>{detail}</span>
      </div>
      {state === "stopped" && p.stop_address && <div style={{ color: "#CCD", fontSize: 10 }}>{p.stop_address}</div>}
      <div style={{ color: "#6A7A8A", fontSize: 10 }}>{p.source?.toUpperCase()} · LAST {fmtClock(p.last_update)}</div>
    </div>
  );
}

export function GpsUnitList({ positions, now, onFocus }) {
  const order = { moving: 0, stopped: 1, stale: 2, lost: 3 };
  const sorted = [...(positions || [])].sort((a, b) => order[motionState(a, now)] - order[motionState(b, now)] || (a.mapped_unit_name || "").localeCompare(b.mapped_unit_name || ""));
  const counts = sorted.reduce((acc, p) => { const s = motionState(p, now); acc[s] = (acc[s] || 0) + 1; return acc; }, {});
  return (
    <div data-testid="gps-unit-list" style={{ width: 290, background: "#0a1017", borderLeft: "1px solid #1c2530", display: "flex", flexDirection: "column", fontFamily: mono, fontSize: 11 }}>
      <div style={{ padding: "8px 10px", borderBottom: "1px solid #1c2530", color: "#9AB", letterSpacing: 2, fontWeight: 700 }}>
        GPS TRACKING
        <div style={{ display: "flex", gap: 8, marginTop: 4, letterSpacing: 0, fontSize: 10 }}>
          {["moving", "stopped", "stale", "lost"].map((s) => (
            <span key={s} data-testid={`gps-count-${s}`} style={{ color: STATUS_COLORS[s] }}>{(counts[s] || 0)} {s.toUpperCase()}</span>
          ))}
        </div>
      </div>
      <div style={{ flex: 1, overflow: "auto" }}>
        {sorted.length === 0 && <div style={{ padding: 12, color: "#6A7A8A" }}>No tracked units. Add devices in Admin → GPS Tracking.</div>}
        {sorted.map((p) => <Row key={p.mapped_unit_id} p={p} now={now} onFocus={onFocus} />)}
      </div>
    </div>
  );
}
